<style scoped>
	.collapsed > .when-opened,
	:not(.collapsed) > .when-closed {
		display: none;
	}
</style>

<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Casos</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body>
						<div role="tablist">
							<b-card no-body class="mb-1">
								<b-card-header header-tag="header" class="p-1" role="tab">
									<b-button block href="#" v-b-toggle.accordion-1 variant="info"
											  class="text-white d-flex justify-content-between align-items-center">
										<span>Sin Atender</span>
										<i class="when-closed fa fa-arrow-down" aria-hidden="true"></i>
										<i class="when-opened fa fa-arrow-up" aria-hidden="true"></i>
									</b-button>
								</b-card-header>
								<b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
									<b-card-body class="table-responsive">
										<IncidentTableComponent v-bind:incidents-list="incidentActivesList"
																v-bind:loader="loading"/>
									</b-card-body>
								</b-collapse>
							</b-card>

							<b-card no-body class="mb-1">
								<b-card-header header-tag="header" class="p-1" role="tab">
									<b-button block href="#" v-b-toggle.accordion-in-process variant="info"
											  class="text-white d-flex justify-content-between align-items-center">
										<span>En Proceso</span>
										<i class="when-closed fa fa-arrow-down" aria-hidden="true"></i>
										<i class="when-opened fa fa-arrow-up" aria-hidden="true"></i>
									</b-button>
								</b-card-header>
								<b-collapse id="accordion-in-process" accordion="my-accordion" role="tabpanel">
									<b-card-body class="table-responsive">
										<IncidentTableComponent v-bind:incidents-list="incidentInProcessList"
																v-bind:loader="loading"/>
									</b-card-body>
								</b-collapse>
							</b-card>

							<b-card no-body class="mb-1">
								<b-card-header header-tag="header" class="p-1" role="tab">
									<b-button block href="#" v-b-toggle.accordion-quote-pending variant="info"
											  class="text-white d-flex justify-content-between align-items-center">
										<span>Pendientes de Aprobar Cotización</span>
										<i class="when-closed fa fa-arrow-down" aria-hidden="true"></i>
										<i class="when-opened fa fa-arrow-up" aria-hidden="true"></i>
									</b-button>
								</b-card-header>
								<b-collapse id="accordion-quote-pending" accordion="my-accordion" role="tabpanel">
									<b-card-body class="table-responsive">
										<IncidentTableComponent v-bind:incidents-list="incidentPendingQuoteList"
																v-bind:loader="loading"/>
									</b-card-body>
								</b-collapse>
							</b-card>

							<b-card no-body class="mb-1">
								<b-card-header header-tag="header" class="p-1" role="tab">
									<b-button block href="#" v-b-toggle.accordion-closing variant="info"
											  class="text-white d-flex justify-content-between align-items-center">
										<span>Casos en Cierre</span>
										<i class="when-closed fa fa-arrow-down" aria-hidden="true"></i>
										<i class="when-opened fa fa-arrow-up" aria-hidden="true"></i>
									</b-button>
								</b-card-header>
								<b-collapse id="accordion-closing" accordion="my-accordion" role="tabpanel">
									<b-card-body class="table-responsive">
										<IncidentTableComponent v-bind:incidents-list="incidentClosingList"
																v-bind:loader="loading"
																v-bind:incident-fields="incidentSolvedTableFields"/>
									</b-card-body>
								</b-collapse>
							</b-card>

							<b-card no-body class="mb-1">
								<b-card-header header-tag="header" class="p-1" role="tab">
									<b-button block href="#" v-b-toggle.accordion-3 variant="info"
											  class="text-white d-flex justify-content-between align-items-center">
										<span>Histórico</span>
										<i class="when-closed fa fa-arrow-down" aria-hidden="true"></i>
										<i class="when-opened fa fa-arrow-up" aria-hidden="true"></i>
									</b-button>
								</b-card-header>
								<b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
									<b-card-body class="table-responsive">
										<IncidentTableComponent v-bind:incidents-list="incidentHistoricalList"
																v-bind:loader="loading"
																v-bind:incident-fields="incidentTableFields"/>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import IncidentTableComponent from "../components/IncidentTableComponent";
	import {mapState} from "vuex";

	export default {
		name: "IncidentList",
		components: {
			IncidentTableComponent,
			AccountDetailComponent,
			GoBackComponent,
		},
		data: function () {
			return {
				perPage: 10,
				currentPage: 1,
				currentPageSolved: 1,
				currentPageCanceled: 1,
				incidentTableFields: {
					incidentName: {
						label: 'Título'
					},
					incidentNumber: {
						label: 'Número de Caso'
					},
					ticketID: {
						label: 'Número Ticket'
					},
					showState: {
						label: 'Estado'
					},
					detail: {
						label: 'Detalles'
					}
				},
				incidentSolvedTableFields: {
					incidentName: {
						label: 'Título'
					},
					incidentNumber: {
						label: '#Caso'
					},
					ticketID: {
						label: '#Ticket'
					},
					tracking: {
						label: 'Seguimiento'
					},
					showState: {
						label: 'Estado'
					},
					attentionDate: {
						label: 'F.Atención'
					},
					invoiceNumber: {
						label: 'Factura'
					},
					detail: {
						label: 'Detalles'
					}
				},
				incidentActivesList: [],
				incidentHistoricalList: [],
				incidentCanceledList: [],
				incidentInProcessList: [],
				incidentPendingQuoteList: [],
				incidentClosingList: [],
				accountSelected: '',
				incidentsLoaded: false,
				loading: false,
			}
		},
		mounted() {
			if (this.$store.state.accountSelected !== '') {
				this.accountSelected = this.$store.state.accountSelected;
				this.getIncidents();
			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			getIncidents() {
				this.loading = true;
				this.$store.dispatch('getIncidents')
					.then((incidents) => {
						for (let i = 0; i < incidents.length; i++) {
							let incident = incidents[i];
							if (incident.state === 2) {
								incident.showState = 'Inactivo';
								this.incidentHistoricalList.push(incident);
							} else if (incident.TrackingCode === 100000000) {
								this.incidentActivesList.push(incident);
							} else if (incident.TrackingCode === 100000001 || incident.TrackingCode === 100000004 || incident.TrackingCode === 100000002 || incident.TrackingCode === 100000007) {
								this.incidentInProcessList.push(incident);
							} else if (incident.TrackingCode === 100000006) {
								this.incidentPendingQuoteList.push(incident);
							} else if (incident.TrackingCode === 100000005 || incident.TrackingCode === 100000003) {
								this.incidentClosingList.push(incident);
							}
						}
					})
					.finally(() => {
						this.loading = false;
					})
			}
		}
	}
</script>

<style scoped>

</style>
